import { FolderMarkerOutlineIcon } from './FolderMarkerOutlineIcon';

/**
 * author: Andrea Antonello
 * id A542AF06-5931-4B8A-8DE0-777F11304ACC
 * name folder-marker-outline
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-marker-outline.svg
 * tags
 * - Geographic Information System 
 * - Files / Folders 
 * - Navigation 
 */
export const FolderLocationOutlineIcon = FolderMarkerOutlineIcon;
export default FolderLocationOutlineIcon